import React from 'react'
import PropTypes from 'prop-types'

import Font from '@cred/react-font'

import styles from './styles.module.scss'

// This needs to be sentence cased rather than title cased
export const toSentenceCase = (text) => {
  const textArray = text.split(' ')
  const firstWord = textArray.shift()
  const formattedFirstWord = firstWord.charAt(0).toUpperCase() + firstWord.slice(1)
  const formattedText = textArray.reduce((accumulator, word) => {
    const updatedAccumulator = `${accumulator} ${word.toLowerCase()}`

    return updatedAccumulator
  }, formattedFirstWord)

  return formattedText.trim()
}

export const withCommas = (number) => parseInt(number, 10).toLocaleString()

export const parseCreditNeeded = ({ creditNeeded, worstCreditScoreCategory }) => {
  if (creditNeeded.includes('new-credit')) {
    return 'No minimum'
  }

  return worstCreditScoreCategory
}

export const RewardsDetails = ({
  annualFeeFormatted,
  rewardsRate,
  introBonus,
  introBonusPoints,
  rewardsUnit,
}) => (
  <>
    <Section name="Annual Fee" value={annualFeeFormatted} />
    <Section name="Rewards Rate" value={toSentenceCase(rewardsRate)} />
    <Section
      name="Welcome Offer"
      value={
        rewardsUnit === 'dollars'
          ? `$${withCommas(introBonus)}`
          : `${withCommas(introBonusPoints)} points`
      }
    />
  </>
)

export const BalanceTransferDetails = ({
  introBalanceTransferPeriodFormatted,
  balanceTransferFeeFormatted,
}) => (
  <>
    <Section name="0% Balance Transfer Period" value={introBalanceTransferPeriodFormatted} />
    <Section name="Balance Transfer Fee" value={balanceTransferFeeFormatted} />
  </>
)

export const SecuredDetails = ({
  annualFeeFormatted,
  securityDepositMinimum,
  worstCreditScoreCategory,
  creditNeeded,
}) => (
  <>
    <Section name="Annual Fee" value={annualFeeFormatted} />
    <Section name="Security Deposit Min." value={`$${withCommas(securityDepositMinimum)}`} />
    <Section
      name="Credit Needed"
      value={parseCreditNeeded({ creditNeeded, worstCreditScoreCategory })}
    />
  </>
)

const Section = ({ name, value }) => (
  <div className={styles.sectionWrapper}>
    <Font className={styles.section} color="lighter">
      {name}
    </Font>
    <Font className={styles.section} color="neutral" weight="semiBold">
      {value}
    </Font>
  </div>
)

const getFeaturedDetailsComponent = (slug) => {
  switch (slug) {
    case 'secured':
      return SecuredDetails
    case 'balance-transfer':
      return BalanceTransferDetails
    case 'rewards':
    default:
      return RewardsDetails
  }
}

const BottomDetails = ({ featuredCategorySlug, ...rest }) => {
  const FeaturedDetailsComponent = getFeaturedDetailsComponent(featuredCategorySlug)

  return (
    <section className={styles.bottomSection}>
      <FeaturedDetailsComponent {...rest} />
    </section>
  )
}

BottomDetails.propTypes = {
  featuredCategorySlug: PropTypes.string,
}
RewardsDetails.propTypes = {
  annualFeeFormatted: PropTypes.string,
  rewardsRate: PropTypes.string,
  introBonus: PropTypes.number,
  introBonusPoints: PropTypes.number,
  rewardsUnit: PropTypes.string,
}

BalanceTransferDetails.propTypes = {
  introBalanceTransferPeriodFormatted: PropTypes.string,
  balanceTransferFeeFormatted: PropTypes.string,
}
SecuredDetails.propTypes = {
  annualFeeFormatted: PropTypes.string,
  securityDepositMinimum: PropTypes.number,
  worstCreditScoreCategory: PropTypes.string,
  creditNeeded: PropTypes.array,
}
Section.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
}

export default BottomDetails
